
import { createSlice } from "@reduxjs/toolkit";

import { IADPState, NetworkConnectionTypes, SessionDetails, appPhase } from "shared/typings";
import { LoggPrefix, randomstring } from "shared/util";
import { InternetInitialState } from "./initialState";
export const internetReducerSlice = createSlice({
    name:'InternetAppState',
    initialState:InternetInitialState,
    reducers:{
        createSetNetworkConnection(state:IADPState,action:{type:string,payload:NetworkConnectionTypes}){
            const NewState = {
                ...state,
                npnAppState: {
                    networkConnection: action.payload  
                }
            }
            return NewState;
        },
        createSetInitiliizeOnlineFlow (state:IADPState){
            state.appState.currentPhase = state.appState.appPhases[0].name
        },
        
        createSetNextPhase(state:IADPState,action:{type:string,payload:appPhase["status"]}){
            //find current phase
        const currentPhase = state.appState.appPhases.find(phase=>phase.name === state.appState.currentPhase) ;
        const currentPhaseIndx = state.appState.appPhases.findIndex(phase=>phase.name === state.appState.currentPhase);
         if(currentPhase){
            currentPhase.status = action.payload;
            const nextPhase = state.appState.appPhases[currentPhaseIndx+1]?.name
            if(action.payload === "Completed" ){
                console.log(LoggPrefix,"current phase -->", currentPhase?.name,"next phase --> ",nextPhase);
                if(nextPhase){
                    state.appState.appPhases[currentPhaseIndx+1].status = "InProgress";
                    state.appState.currentPhase = state.appState.appPhases[currentPhaseIndx+1]?.name   
                }
             }
              }
        },
        createRedirectToSCI(state:IADPState){
            state.appState.currentView = "RedirectionView";
            state.sessionState.lastKnownGoodState = "RedirectionView";
        },
        createSetDateTimeCheck(state:IADPState,action:{type:string,payload:boolean}){
            state.deviceState.isDateTimeValid  = action.payload
        }, 
        createSetNPNSessionDetailsAction(state:IADPState,action:{type:string,payload:Record<string, unknown>}){
            const sessionDetails= action.payload as SessionDetails
                state.appState={
                ...state.appState,
                appLaunchId:sessionDetails.appLaunchId,
                environment: sessionDetails.environment,
                runtimePlatform: sessionDetails.runtimePlatform,
                isPageReloaded: sessionDetails.isPageReloaded,
                extensionVersion: sessionDetails.extensionVersion
               }, 
               state.sessionState={
                ...state.sessionState,
                tryAgainAfterFailure: false,
                networkConnectionState: sessionDetails.networkConnectionState ? sessionDetails.networkConnectionState : state.sessionState.networkConnectionState
               },
                state.deviceState={
                    ...state.deviceState,
                    deviceId: sessionDetails.deviceId,
                    deviceModel: sessionDetails.deviceModel,
                    deviceType: sessionDetails.deviceType,
                    systemInfo: sessionDetails.systemInfo
                },
                state.updateState.isCheckForUpdateEnabled= sessionDetails?.isCheckForUpdateEnabled !== undefined ? sessionDetails.isCheckForUpdateEnabled : false
        }   
    }
})
export const { 
    createSetDateTimeCheck,
    createRedirectToSCI,
    createSetNPNSessionDetailsAction,
    createSetNetworkConnection,
    createSetInitiliizeOnlineFlow,
    createSetNextPhase
     } = internetReducerSlice.actions
export default internetReducerSlice.reducer
